module.exports = __webpack_public_path__ + "files/f960d1195a1a9a7287b7018fb154f4f7.png";